module.exports = __webpack_public_path__ + "static/media/022.c39acfe6.jpg";